import React, { useContext } from 'react';
import {
  TargetFieldCategory,
  TargetFieldContext,
} from '../../../../../services/common/CalculatorUtils';
import TargetFieldDataForThirdParty from './thirdParty/DataForThirdParty';
import TargetFieldDataForDossier from './dossier/DataForDossier';
import TargetFieldDataForDocument from './document/DataForDocument';
import TargetFieldDataForSourceVariable from './sourceVariable/DataForSourceVariable';
import TargetFieldDataForContext from './context/DataForContext';

const TargetFieldData = ({ fieldName, readOnly = false }) => {
  const { selectedTargetFieldCategory } = useContext(TargetFieldContext);

  switch (selectedTargetFieldCategory) {
    case TargetFieldCategory.THIRD_PARTY:
      return (
        <TargetFieldDataForThirdParty
          fieldName={`${fieldName}.data_for_third_party`}
          readOnly={readOnly}
        />
      );

    case TargetFieldCategory.DOSSIER:
      return (
        <TargetFieldDataForDossier
          fieldName={`${fieldName}.data_for_dossier`}
          readOnly={readOnly}
        />
      );

    case TargetFieldCategory.DOCUMENT:
      return (
        <TargetFieldDataForDocument
          fieldName={`${fieldName}.data_for_document`}
          readOnly={readOnly}
        />
      );

    case TargetFieldCategory.SOURCE_VARIABLE:
      return (
        <TargetFieldDataForSourceVariable
          fieldName={`${fieldName}.data_for_source_variable`}
          readOnly={readOnly}
        />
      );
    case TargetFieldCategory.CONTEXT:
      return (
        <TargetFieldDataForContext
          fieldName={`${fieldName}.data_for_context`}
          readOnly={readOnly}
        />
      );

    default:
      return <></>;
  }
};

export default TargetFieldData;
